export const cloneError = <InputError extends Error, OutputError extends Error>(
  error: InputError,
  OutputErrorConstructor: new(...args: any[]) => OutputError,
  ...outputErrorArguments: any[]
): OutputError => {
  const clonedError = new OutputErrorConstructor(error.message, ...outputErrorArguments);
  clonedError.stack = error.stack;
  return clonedError as OutputError;
};
